import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

// Utilitaire pour formater la date (dd-MM-yyyy)
function formatDateDisplay(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

/**
 * @param {Object[]} achats - Liste des achats
 * @param {Object[]} fournisseurs - Liste des fournisseurs (optionnel)
 */
const AchatsLies = ({ achats, fournisseurs = [] }) => {
  // Index fournisseurs par id ou uuid (toujours appelé avant tout return)
  const fournisseursMap = React.useMemo(() => {
    const map = {};
    fournisseurs.forEach(f => {
      if (f.id) map[f.id] = f.Titre;
      if (f.uuid) map[f.uuid] = f.Titre;
    });
    return map;
  }, [fournisseurs]);

  if (!achats || achats.length === 0) {
    return <Typography variant="caption" sx={{ color: '#888' }}>Aucun achat lié</Typography>;
  }
  // Tri du plus récent au plus ancien
  const sorted = [...achats].sort((a, b) => new Date(b["DateAchat"] || b.dateAchat) - new Date(a["DateAchat"] || a.dateAchat));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>Achats</Typography>
      {sorted.map(achat => {
        const prix = achat.prixAchat !== undefined ? achat.prixAchat : achat["Prix d'achat"];
        // Trouver le nom du fournisseur
        let fournisseur = '-';
        if (achat.Fournisseur && typeof achat.Fournisseur === 'object' && achat.Fournisseur.Titre) {
          fournisseur = achat.Fournisseur.Titre;
        } else if (achat.Fournisseur && fournisseursMap[achat.Fournisseur]) {
          fournisseur = fournisseursMap[achat.Fournisseur];
        } else if (achat.fournisseur && typeof achat.fournisseur === 'object' && achat.fournisseur.Titre) {
          fournisseur = achat.fournisseur.Titre;
        } else if (achat.fournisseur && fournisseursMap[achat.fournisseur]) {
          fournisseur = fournisseursMap[achat.fournisseur];
        } else if (achat.Fournisseur) {
          fournisseur = achat.Fournisseur;
        } else if (achat.fournisseur) {
          fournisseur = achat.fournisseur;
        }
        return (
          <Box
            key={achat.id}
            sx={{
              px: 0.5,
              borderRadius: 1.5,
              transition: 'background 0.15s',
              '&:hover': { background: '#f5f7fa' },
              mb: 0.2
            }}
          >
            
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
              <Typography variant="body2" sx={{ color: '#222', fontWeight: 500 }}>{formatDateDisplay(achat["DateAchat"] || achat.dateAchat)}</Typography>
              <Typography variant="body2" sx={{ color: '#c62828', fontWeight: 700 }}>{prix !== undefined ? Number(prix).toFixed(2) + ' €' : '-'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mt: 0.1 }}>
              <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 500, maxWidth: 120, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{achat.SKUID || achat.skuid || '-'}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, maxWidth: 120 }}>
                <BusinessIcon sx={{ color: '#bdbdbd', fontSize: 18 }} />
                <Tooltip title={fournisseur} arrow>
                  <Typography variant="body2" sx={{ color: '#888', fontWeight: 400, maxWidth: 90, textAlign: 'right', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{fournisseur}</Typography>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AchatsLies; 